<template>
  <nav aria-label="Primary navigation" class="navbar navbar-expand-lg navbar-dark bg-primary">
    <div class="container-fluid">
      <span class="navbar-brand" href="#">
        <img src="../../assets/logo-reverse.png" alt="Minnesota Department of Health Logo" class="me-4" style="height:38px;"/>
        <span class="text-white fs-4">{{ appTitle }}</span>
      </span>

      <button  v-if="store.authenticated && !store.loadingProfile" class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon "></span>
      </button>
      <div class="collapse navbar-collapse justify-content-end" id="navbarSupportedContent">
        <div class="d-flex justify-content-start">
          <PvButton v-if="store.authenticated && !store.loadingProfile" icon="pi pi-user" arial-label="View user profile" class="nav-item me-3" title="View your general profile details." rounded @click="toggleUserPopover" />
          <PvButton v-if="store.authenticated && !store.loadingProfile && store.user.isHceOnlyUser" title="Sign out" @click="store.logout()">Sign Out</PvButton>
          <UserAppMenu v-if="store.authenticated && !store.loadingProfile && !store.user.isAdminUser && !store.user.isHceOnlyUser" />
          <ProgramAppMenu v-if="store.authenticated && !store.loadingProfile && store.user.isAdminUser" />
        </div>
      </div>
    </div>
  </nav>
  <Popover ref="op">
    <div class="p-3 d-flex">
      <div class="me-4">
        <Avatar :label="store.user.initials" size="large" shape="circle" />
      </div>
      <div>
        {{ store.user.firstName }} {{ store.user.lastName }}
        <br />
        <small>{{ store.user.primaryOrganizationName }}</small>      
      </div>
    </div>
  </Popover>
</template>

<script setup>

import { useAuthStore } from '@/stores/authStore';
import UserAppMenu from './UserAppMenu.vue';
import ProgramAppMenu from './ProgramAppMenu.vue';
import Popover from 'primevue/popover';
import Avatar from 'primevue/avatar';
import { ref } from 'vue';

const op = ref();
const toggleUserPopover = (event) => op.value.toggle(event);

const store = useAuthStore();
const appTitle = import.meta.env.VITE_APP_TITLE;

</script>